<template>
    <div class="con">
        <!--      <div class="top"></div>-->
        <div class="main">
            <!-- <div class="html" v-html="info.CONTENT"></div> -->
            <div class="html">
                <img class="bannerImg" src="https://www.cabling-vivanco.com/upload/2020050915113744.jpg" alt/>
                <img class="bannerImg" src="../assets/solu/education.jpg" alt/>
                <div class="nav">
                    <a href="./health.html" target="_self">Healthcare</a>
                    <a href="./education.html" target="_self">Education</a>
                    <a>Transportation</a>
                    <a>Finance</a>
                    <a href="./PoE.html" target="_self">Power over Ethernet (PoE)</a>
                </div>
                <div class="html_body">
                    <div class="item">
                        <div class="content">
                            <p>Technology is everywhere in today’s education industry, and is causing the digital
                                transformation from the traditional and physical environment to an interactive learning
                                space, where a variety of mechanical and software technologies will be used for
                                improving the learning experience. Especially those state-of-the-art technologies,
                                including The Internet of Things (IoT), Virtual Reality (VR) Augmented Reality (AR),
                                Cloud Computing and Analytics, Artificial Intelligence (AI), not only alter the way we
                                perceive education, but also bring inevitable challenges to the design and installation
                                of network infrastructure while building a smart campus.</p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="content">
                            <div class="title">Challenges</div>
                            <p>With such humongous advancements in technology, educational institutes need to cope up
                                with them and be ready to adapt, and accordingly improve their teaching methods or
                                building design to attract and retain students. These new trends will require a correct
                                network infrastructure that could address the challenges of today and tomorrow.</p>
                            <div class="point">
                                <p>High-speed, reliable, and secure network to ensure online education or online school,
                                    and more</p>
                            </div>
                            <div class="point">
                                <p>Seamless wireless connectivity for increasing mobile devices and online applications
                                    across campus</p>
                            </div>
                            <div class="point">
                                <p>Secure and user-friendly solutions for better protection against students and
                                    staffs</p>
                            </div>
                            <div class="point">
                                <p>Simplified/intelligent network administration and upgrades to enhance security and
                                    efficiency, and minimize the maintenance cost</p>
                            </div>
                            <div class="point">
                                <p>Big data and analytics will be gradually implemented to better understand students,
                                    and improve daily management and operations</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="case_study">
                <p class="title">VIVANCO EDUCATION SOLUTIONS</p>
                <div class="tabs-section">
                    <div class="tabs-header-wrapper">
                        <div class="items">
                            <div
                                    class="item"
                                    v-for="(item,index) in list"
                                    :key="index"
                                    @click="getNum(index)"
                                    :class="{active:num===index}"
                            >{{item}}
                            </div>
                        </div>
                    </div>
                    <transition name="fade">
                    <div class="tabs-column" v-if="num==0">
                        <div class="content">
                            <p>More and more large or small educational institutes are increasingly embracing the
                                concept of Smart Campus, and they could continually develop new, innovative approaches
                                for improved student enrollment, enhanced student learning and quality of life, higher
                                security and safety, greater institutional efficiency, and lower operation cost, through
                                the use of new technologies based on a well-architected infrastructure. VIVANCO
                                structured cabling and data center solutions can help develop an infrastructure
                                connectivity platform that benefits students, faculty, and administrators in today’s and
                                tomorrow’s campus.</p>
                        </div>
                        <div class="cloumn_control">
                            <div class="column_box">
                                <div class="column_item" v-for="(item1,index1) in cloumnList" :key="index1">
                                    <img :src="`${item1.img}`"/>
                                    <div class="column_item_text">
                                        <div class="column_title">
                                            <p>{{item1.title}}</p>
                                        </div>
                                        <div class="content" v-for="(item2,index2) in item1.content" :key="index2">
                                            <p @click="getOpen(index1,index2)">{{item2}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </transition>
                    <transition name="fade">
                    <div class="tabs-allItems" v-if="num==1">
                        <div class="allItems">
                            <div class="item">
                                <div>
                                    <img src="https://www.cabling-vivanco.com/sunsemweb/img/one.svg" alt/>
                                </div>
                                <p>One-stop services</p>
                                <p>One-stop services for both Cabling and Data Center Infrastructure</p>
                            </div>
                            <div class="item">
                                <div>
                                    <img src="https://www.cabling-vivanco.com/sunsemweb/img/two.svg" alt/>
                                </div>
                                <p>Reliable and high-speed network connectivity</p>
                                <p>Reliable and high-speed network connectivity for both on-campus and remote access</p>
                            </div>
                            <div class="item">
                                <div>
                                    <img src="https://www.cabling-vivanco.com/sunsemweb/img/three.svg" alt/>
                                </div>
                                <p>Flexible and scalable solutions</p>
                                <p>Flexible and scalable solutions for what you need now and future expansion as your
                                    business grows</p>
                            </div>
                            <div class="item">
                                <div>
                                    <img src="https://www.cabling-vivanco.com/sunsemweb/img/four.svg" alt/>
                                </div>
                                <p>Intelligent communication infrastructure</p>
                                <p>Intelligent communication infrastructure that could be applied for next-generation
                                    technologies to keep you at the forefront and improve educational facilities</p>
                            </div>
                        </div>
                    </div>
                    </transition>
                    <transition name="fade">
                    <div class="tabs-study" v-if="num==2">
                        <div class="item" v-for="(item,index) in caseList" :key="index">
                            <img :src="`https://www.cabling-vivanco.com/upload/${item.SMALLPIC}`" alt />
                            <div class="text">
                                <div class="t">{{item.TITLE}}</div>
                                <div class="c">{{item.ZY}}</div>
                            </div>
                            <a
                                    class="btn"
                                    :href="`https://www.cabling-vivanco.com/upload/${item.FILE}`"
                                    target="_blank"
                            >Learn more</a>
                        </div>
                    </div>
                    </transition>
                </div>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import { getNewsUrl} from "../util/lang";
    import footComponent from "../components/foot";

    export default {
        name: "health",
        data() {
            return {
                info: {},
                num: 0,
                cloumnList: [
                    {
                        img: "https://www.cabling-vivanco.com/upload/s1.jpg",
                        title:
                            "Copper Cabling Solutions for high speed transmission and PoE applications",
                        content: ["Shielded CAT6A Solutions", "Unshielded CAT6A Solutions"]
                    },
                    {
                        img: "https://www.cabling-vivanco.com/upload/s2.jpg",
                        title:
                            "Optical Fiber Solutions for high density and high bandwidth applications",
                        content: ["SM/OM3/OM4 Optical Fiber Cabling Solutions"]
                    },
                    {
                        img: "https://www.cabling-vivanco.com/upload/s3.jpg",
                        title: "Rack & Cabinet Solutions for storage of network devices",
                        content: ["Rack and Cabinet Solutions"]
                    },
                    {
                        img: "https://www.cabling-vivanco.com/upload/s4.jpg",
                        title: "Data Center Solutions",
                        content: [
                            "Vericom® Micro Data Center  Solutions for small-size branch of hospitals"
                        ]
                    },
                    {
                        img: "https://www.cabling-vivanco.com/upload/s5.jpg",
                        title: "Aisle Containment Solutions",
                        content: [
                            "Vericom® Aisle Containment Solutions offer flexible approach while utilizing hybrid/mix cooling methodologies"
                        ]
                    }
                ],
                list: ["Product Solutions", "Features & Benefits", "Case Study"],
                caseList:[]
            };
        },
        components: {footComponent},
        mounted() {
            this.$nextTick(() => {
              this.getCaseStudy("36");
            });
        },
        methods: {
            getCaseStudy(id){
                const url = `${getNewsUrl('zh-CN',id,10000,1)}`
                this.$axios.get(url).then(res => {
                    this.caseList=res.data.newsArr
                })
            },
            getOpen(index1, index2) {
                if (index1 === 0) {
                    if (index2 === 0) {
                        const link = `/pro.html?id=58`;
                        window.open(link, "_blank");
                    } else {
                        const link = `/pro.html?id=59`;
                        window.open(link, "_blank");
                    }
                } else if (index1 === 1) {
                    const link = `/pro.html?id=69`;
                    window.open(link, "_blank");
                } else if (index1 === 2) {
                    const link = `/pro.html?id=72`;
                    window.open(link, "_blank");
                } else {
                    return;
                }
            },
            getNum(num) {
                this.num = num;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .con {
        width: 100%;

        .top {
            width: 100%;
            background-color: black;
            height: 127px;
        }

        .main {
            width: 100%;
            margin: 0 auto;
            .nav {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin: 0 auto;
                display: none;
                a{
                    border: 1px solid #B3B3B3;
                    padding: 5px 80px;
                    text-align: center;
                    line-height: 30px;
                    margin-left: 10px;
                    cursor: pointer;
                    transition: all 600ms;
                    font-family: "Fira Code Medium";
                    font-weight: lighter;
                }
                a:hover {
                    color: white;
                    background-color: #91C131;
                }

                a:nth-child(2){
                    color: white;
                    background-color: #91C131;
                }
            }
            .title {
                margin: 60px auto;
                font-family: os;
                font-size: 25px;
                text-align: center;
                padding-bottom: 10px;
                position: relative;
                text-transform: uppercase;

                &::before {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    top: 97%;
                    width: 24%;
                    height: 1px;
                    left: 38%;
                    background-color: #ededed;
                }

                &::after {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    bottom: 2%;
                    left: 44%;
                    width: 12%;
                    height: 1px;
                    background-color: #91c131;
                    border-radius: 1px;
                }
            }

            .html {
                line-height: 30px;

                img:nth-child(1) {
                    display: block;
                    width: 100%;
                }
                img:nth-child(2){
                    display: none;
                    width: 100%;
                }

                .html_body {
                    width: 80%;
                    margin: 30px auto;

                    .item {
                        .content {
                            .subtitle {
                                font-family: "Fira Code Medium";
                                font-weight: bold;
                            }

                            p {
                                font-family: "Fira Code Medium";
                                font-weight: lighter;
                                line-height: 35px;
                                // text-indent: 2em;
                            }

                            .point {
                                position: relative;
                                padding-left: 30px;

                                &::after {
                                    content: "";
                                    position: absolute;
                                    left: 1%;
                                    top: 41%;
                                    height: 6px;
                                    width: 6px;
                                    border-radius: 50%;
                                    background-color: #8888;
                                }
                            }
                        }
                    }
                }
            }

            .case_study {
                width: 80%;
                padding: 20px 0;
                margin: 0 auto;

                p {
                    font-family: os;
                }

                .tabs-section {
                    max-width: 1500px;
                    padding: 20px 0;
                    margin: 0 auto;

                    .tabs-header-wrapper {
                        width: 100%;
                        border-bottom: 2px solid #ededed;
                        height: 35px;

                        .items {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: row;
                            position: relative;
                            left: 50%;
                            transform: translateX(-50%);

                            .item {
                                width: 33%;
                                text-align: center;
                                position: relative;
                                cursor: pointer;
                                transition: all 600ms;
                                font-family: "Fira Code Light";
                                font-weight: lighter;
                                text-transform: uppercase;

                                &::after {
                                    content: "";
                                    display: inline-block;
                                    height: 2px;
                                    width: 0;
                                    position: absolute;
                                    left: 24%;
                                    bottom: -1px;
                                    background-color: #91c131;
                                    transition: 600ms;
                                }

                                &:hover {
                                    color: #91c131;

                                    &::after {
                                        width: 50%;
                                    }
                                }
                            }

                            .active {
                                color: #91c131;

                                &::after {
                                    width: 50%;
                                }
                            }
                        }
                    }

                    .tabs-column {
                        margin-top: 30px;

                        .content {
                            p {
                                font-family: "Fira Code Medium";
                                font-weight: lighter;
                                line-height: 35px;
                                // text-indent: 2em;
                            }
                        }

                        .cloumn_control {
                            margin-top: 35px;
                            width: 100%;

                            .column_box {
                                width: 100%;
                                margin: 40px auto;
                                display: flex;
                                flex-direction: row;
                                flex-wrap: wrap;
                                justify-content: space-between;

                                .column_item {
                                    width: 48%;
                                    display: flex;
                                    flex-direction: row;
                                    margin-bottom: 5%;

                                    img {
                                        width: 50%;
                                        height: auto;
                                        transition: all 600ms;
                                        cursor: pointer;

                                        &:hover {
                                            transform: scale(1.05);
                                        }
                                    }

                                    .column_item_text {
                                        display: flex;
                                        flex-direction: column;
                                        width: 45%;
                                        margin-left: 5%;

                                        .column_title {
                                            font-family: os;
                                            font-size: 20px;
                                            padding-bottom: 10px;

                                            p {
                                                position: relative;
                                                left: 0;
                                            }
                                        }

                                        .content {
                                            font-size: 14px;
                                            padding-bottom: 10px;
                                            padding-left: 5%;
                                            flex-direction: row;
                                            position: relative;
                                            &:active{
                                                color: #91c131;
                                            }
                                            p {
                                                // color: red;
                                                line-height: 25px;
                                                font-family: "Fira Code Medium";
                                                font-weight: lighter;
                                                cursor: pointer;
                                                text-decoration: underline;
                                            }

                                            &::before {
                                                content: "";
                                                background-color: black;
                                                position: absolute;
                                                top: 10px;
                                                left: 0;
                                                display: inline-block;
                                                width: 6px;
                                                height: 6px;
                                                border-radius: 50%;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .tabs-allItems {
                        .allItems {
                            width: 100%;
                            margin: 0 auto;
                            display: flex;
                            flex-direction: row;
                            flex-wrap: wrap;
                            justify-content: space-between;
                            margin-bottom: 40px;

                            .item {
                                width: 20%;
                                cursor: pointer;
                                margin-top: 40px;
                                text-align: center;

                                div {
                                    img path {
                                        fill: #27abff;
                                    }
                                }

                                p:nth-of-type(1) {
                                    font-family: os;
                                    font-weight: bold;
                                    margin: 15px auto;
                                    height: 60px;
                                    text-transform: uppercase;
                                    line-height: 30px;
                                }

                                p:nth-of-type(2) {
                                    line-height: 25px;
                                    font-family: "Fira Code Medium";
                                    font-weight: lighter;
                                }
                            }
                        }
                    }

                    .tabs-study {
                        margin: 30px auto;
                        width: 100%;
                        // line-height: 30px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;

                        .item {
                            width: 25%;
                            margin: 20px 4%;
                            display: flex;
                            flex-direction: column;
                            // padding: 10px;
                            border: 1px solid #cfcfcf;
                            align-items: center;
                            position: relative;
                            cursor: pointer;
                            transition: all 600ms;
                            padding-bottom: 60px;
                            overflow: hidden;

                            img {
                                width: 100%;
                                height: 214px;
                                object-fit: cover;
                                transition: all 2s;
                            }

                            .text {
                                width: 90%;
                                margin-bottom: 20px;
                                padding: 10px 0;

                                .t {
                                    font-weight: bold;
                                }

                                .c {
                                    margin: 10px auto;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    line-height: 30px;
                                    font-family: "Fira Code Light";
                                    font-weight: lighter;
                                }
                            }

                            .btn {
                                border: 1px solid #91c131;
                                color: #91c131;
                                font-size: 18px;
                                text-align: center;
                                padding: 5px 10px;
                                position: absolute;
                                font-family: "Fira Code Light";
                                font-weight: lighter;
                                bottom: 5%;
                                left: 58%;
                                // transform: translateX(-50%);
                            }

                            &:hover {
                                img {
                                    transform: scale(1.05);
                                }
                            }
                        }
                    }
                }
            }
        }

        @media screen and (max-width: 1440px) {
            .top {
                height: 100px;
            }
            .main {
                width: 100%;
                .case_study{
                    .tabs-section{
                        .tabs-study{
                            .item{
                                .btn{
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 1000px) {
            .main {
                width: 100%;
                .nav{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: normal;
                    a{
                        padding: 5px 0;
                        width: 100%;
                        text-align: center;
                        margin-left: 0;
                        border: none;
                    }
                }
                .html {

                    img:nth-child(1){
                        display: none;
                    }
                    img:nth-child(2) {
                        display: block;
                        height: 300px;
                        object-fit: cover;
                    }
                    width: 100%;
                    .html_body {
                        width: 90%;
                    }
                }

                .title {
                    &::before {
                        width: 70%;
                        left: 15%;
                    }

                    &::after {
                        width: 35%;
                        left: 32.5%;
                    }
                }

                .cloumn_control {
                    width: 100%;

                    .column_box {
                        width: 100%;
                        flex-direction: column;
                        align-items: center;

                        .column_item {
                            width: 100%;
                            display: flex;
                            flex-direction: column;

                            img {
                                width: 80%;
                                margin: 0 auto;
                            }

                            .column_item_text {
                                width: 80%;
                                margin: 10px auto 0 auto;
                            }
                        }
                    }
                }

                .allItems {
                    width: 90%;

                    .item {
                        width: 100%;
                        text-align: center;
                    }
                }

                .case_study {
                    width: 100%;

                    .tabs-section {
                        width: 100%;

                        .tabs-content {
                            .text {
                                width: 90%;

                                a {
                                    display: inline-block;
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1000px) {
        .con{
            .main{
                .case_study {
                    .tabs-section {
                        .tabs-header-wrapper {
                            .items {
                                .item {
                                    font-size: 12px;
                                }
                            }
                        }
                        .tabs-column{
                            width: 90%;
                            margin: 0 auto;
                            .cloumn_control{
                                .column_box{
                                    width: 100%;
                                    flex-direction: column;
                                    .column_item{
                                        width: 100%;
                                        flex-direction: column;
                                        img{
                                            width: 100%;
                                        }
                                        .column_item_text{
                                            width: 100%;
                                            margin: 0 auto;
                                            .column_title{
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .tabs-allItems{
                            width: 100%;
                            .allItems{
                                width: 90%;
                                margin: 0 auto;
                                flex-direction: column;
                                .item{
                                    width: 100%;
                                    margin: 0 auto;
                                    margin-top: 30px;
                                }
                            }
                        }
                        .tabs-study{
                            width: 100%;
                            .item{
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }

    }
</style>
<style scoped>
    .html >>> p img {
        width: 100%;
        margin: 0 auto;
        object-fit: cover;
    }

    @media screen and (max-width: 750px) {
        .html >>> p img {
            height: 300px;
        }

        .html >>> div a {
            margin-left: 0 !important;
        }
    }
</style>
